import type { Country } from '@/pages/articlesSights/entities/cityArticles/models';
import type { Country as EncodedCountry } from '@/shared/api/experience';

/**
 * Преобразует данные из API во внутреннее представление страны города.
 *
 * @param encoded данные из API
 * @returns внутреннее представление
 */
export const normalizeCountry = (encoded?: EncodedCountry): Country => {
  return {
    acrossObjPhrase: encoded?.across_obj_phrase ?? '',
    currency: encoded?.currency ?? '',
    experienceCount: encoded?.experience_count ?? 0,
    geoAccessLevel: encoded?.geo_access_level,
    id: encoded?.id ?? 0,
    inObjPhrase: encoded?.in_obj_phrase ?? '',
    nameEn: encoded?.name_en ?? '',
    nameRu: encoded?.name_ru ?? '',
    region: encoded?.region ?? '',
    slug: encoded?.slug ?? '',
    url: encoded?.url ?? '',
  };
};
